import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { toast } from 'react-toast'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import DefaultLayout from '../components/DefaultLayout'

const Input = styled.input`
    padding: 0.9285714286em 0.7857142857em;
    font-size: 14px;
    background-color: white;
    color: #333333;
    border-radius: 5px;
    transition: all 0.2s ease-out;
    border: 1px solid #d9d9d9;
    width: 100%;
    &:nth-child(n + 3) {
        margin-top: 12px;
    }
`
const Row = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 14px;
`

const ShippingBtn = styled.button`
    padding: 20px 24px;
    background: #1b1b1b;
    font-size: 14px;
    border: none;
    margin: 25px 0 0;
    font-weight: 600;
    color: #fff;
    border-radius: 5px;
    transition: .2s all ease;
    &:hover {
        background: #000;
    }
`

const Checkout = () => {
    const history = useHistory()
    const [gift, setGift] = useState('')
    const [form, setForm] = useState({
        firstName: "",
        secondName: "",
        company: "",
        adress: "",
        apartment: "",
        city: "",
        phone: "",
    })

    const doIt = () => {
        history.push('/catalog')
        toast.success('Successfully done! 🚚')
    }

    return (
        <div className="checkout">
            <div className="wrapper">
                <div className="checkout_content">
                    <div className="checkout_left">
                        <img
                            src="https://cdn.shopify.com/s/files/1/0319/8225/6172/files/hillsmade.jpg?19178"
                            alt=""
                            className="logo"
                        />
                        <div className="checkout_navigation">
                            <a href="/">Cart</a>
                            <div className="arrow"></div>
                            <a href="/" className="active">Information</a>
                            <div className="arrow"></div>
                            <a href="/">Shipping</a>
                            <div className="arrow"></div>
                            <a href="/">Payment</a>
                        </div>
                        <div className="checkout_contacts">
                            <div className="row">
                                <h3>Contact information</h3>
                                <span>
                                    Already have an account?{' '}
                                    <a href="/">Log in</a>
                                </span>
                            </div>
                            <Input placeholder="Email or mobile phone number" />
                        </div>
                        <form>
                            <h3>Shipping address</h3>
                            <Row>
                                <Input placeholder="First name" />
                                <Input placeholder="Last name" />
                            </Row>
                            <Input placeholder="Company (optional)" />
                            <Input placeholder="Adress" />
                            <Input placeholder="Apartment, suite, etc. (optional)" />
                            <Input placeholder="City" />
                            <Input placeholder="Phone" />
                        </form>
                        <div className="checkout_btns">
                            <ShippingBtn>Continue to shipping</ShippingBtn>
                            <NavLink to="/cart">Return to cart</NavLink>
                        </div>
                        <div className="checkout_footer">
                            <a href="/">Refund policy</a>
                            <a href="/">Shipping policy</a>
                            <a href="/">Privacy policy</a>
                            <a href="/">Terms of service</a>
                            <a href="/">Legal notice</a>
                        </div>
                    </div>
                    <div className="checkout_right">
                        <div className="checkout_list">
                            <div className="checkout_list_item">
                                <div className="checkout_list_item-image">
                                    <img
                                        src="https://cdn.shopify.com/s/files/1/0319/8225/6172/products/DSC04189_small.jpg?v=1652914214"
                                        alt=""
                                    />
                                    <div className="counter">1</div>
                                </div>
                                <div className="checkout_list_item-column">
                                    <h4>
                                        Lorem ipsum dolor sit amet consectetur
                                        adipisicing elit. Deserunt expedita
                                        error debitis ducimus repellendus illum
                                        impedit ipsa rerum voluptatibus,
                                        provident quisquam nemo
                                    </h4>
                                    <p>Matte</p>
                                </div>
                                <p className="checkout_list_item-cost">
                                    $219.00
                                </p>
                            </div>
                            <div className="checkout_list_item">
                                <div className="checkout_list_item-image">
                                    <img
                                        src="https://cdn.shopify.com/s/files/1/0319/8225/6172/products/DSC04189_small.jpg?v=1652914214"
                                        alt=""
                                    />
                                    <div className="counter">1</div>
                                </div>
                                <div className="checkout_list_item-column">
                                    <h4>Dashboard</h4>
                                    <p>Matte</p>
                                </div>
                                <p className="checkout_list_item-cost">
                                    $279.00
                                </p>
                            </div>
                        </div>
                        <div className="checkout_gift">
                            <div className="checkout_gift_input_block">
                                <label>Gift card or discount code</label>
                                <input
                                    type="text"
                                    onChange={(e) => setGift(e.target.value)}
                                />
                            </div>
                            <button
                                disabled={gift.length === 0 ? 'disabled' : null}
                            >
                                Apply
                            </button>
                        </div>
                        <div className="checkout_info">
                            <div className="row">
                                <p>Subtotal</p>
                                <span>$498.00</span>
                            </div>
                            <div className="row">
                                <p>Discount</p>
                                <span>- $29.88</span>
                            </div>
                            <div className="row">
                                <p>Shipping</p>
                                <span className="text">
                                    Calculated at next step
                                </span>
                            </div>
                        </div>
                        <div className="checkout_total">
                            <p>Total</p>
                            <div className="right">
                                <span>USD</span>
                                $495.12
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Checkout
